import React, { FC } from 'react'
import './styles.scss'

import check from '../../../assets/img/check.png'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { Routes } from '../../../routing/routes'
import { Plann3rStore } from '../../../store/types'

const Confirmation: FC = () => {
  const { copy, display_name, auto_accept } = useSelector(
    (state: Plann3rStore) => state.meetingPage,
  )
  const strings = useSelector(
    (state: Plann3rStore) => state.languages.strings.link.bestmoments,
  )
  
  return (
    <div className="confirmationPage">
      <div className="momentPicked">
        <div className="top has-text-centered">
          <img src={check} alt="Done" />
        </div>
        <div className="quote has-text-centered">
          {copy?.page_outro ? (
            <div dangerouslySetInnerHTML={{ __html: copy.page_outro }}></div>
          ) : strings.thanks + '\n' + strings.soon}
          <br />
          <span>{'- ' + display_name + ' -'}</span>
        </div>
        {!auto_accept && (
          <div className="nextUp mt-6">
            <p className="heavy">{strings.next_up}</p>
            <ul>
              <li>
                {display_name} {strings.next_step1}
              </li>
              <li>
                {strings.next_step2_a} <b>{strings.next_step2_b}</b>{' '}
                {strings.next_step2_c} <b>{strings.next_step2_d}</b>{' '}
                {strings.next_step2_e}
              </li>
            </ul>
            <hr className="my-6" />
            <p className="bold">{strings.why_plann3r}</p>
            <ul>
              <li>{strings.plann3r_1}</li>
              <li>{strings.plann3r_2}</li>
              <li>{strings.plann3r_3}</li>
            </ul>
            <Link
              to={
                Routes.ONBOARDING +
                '?utm_source=page&amp;utm_medium=meetinginvite'
              }
              className="cta"
            >
              {strings.free_meeting_page}
            </Link>
          </div>
        )}
      </div>
    </div>
  )
}

export default Confirmation
